export enum UserRole {
    SUPER_ADMIN = 'super-admin',
    ADMIN = 'admin',
    DOMAIN_OPS = 'domain-ops',
}
